// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1BF4S","content":"GlobalSearch_content__H2EGB"};